/*
 * @Author: mn 1179443407@qq.com
 * @Date: 2022-11-25 10:59:03
 * @LastEditors: yuxh yuxh_157@163.com
 * @LastEditTime: 2024-06-24 11:04:43
 * @FilePath: /akx-factory-main/src/login/main.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import api from "./api";
import component from "./components";
import "./common/common.scss";

Vue.config.productionTip = false;
Vue.prototype.$api = api;
Vue.prototype.$component = component;
function pushIndex() {
  let pathname;
  if (location.pathname.indexOf("login.html") !== -1) {
    pathname = location.pathname.replace("login.html", "index.html");
  } else {
    pathname = location.pathname.replace("/login", "");
  }
  let url = location.origin + pathname;
  location.replace(url);
}
if (
  localStorage.getItem("AKX_AUTO_LOGIN_CONFIG") === "-1" &&
  sessionStorage.getItem("LOGIN_FLAG") !== "1"
) {
  localStorage.removeItem("USER_TOKEN");
  window.$vue = new Vue({
    router,
    render: (h) => h(App),
  }).$mount("#mainApp");
} else {
  api.checkLogin({
    success: () => {
      pushIndex();
    },
    fail: () => {
      window.$vue = new Vue({
        router,
        render: (h) => h(App),
      }).$mount("#mainApp");
    },
  });
}
